import type { TransactionType } from '@/types'

export const TRANSACTIONS_PER_PAGE = 20

export function formatAmountCents(cents: number): string {
  const amount = (cents / 100).toFixed(2)
  return `${amount} €`
}

export const typeBadgeVariant: Record<TransactionType, 'default' | 'destructive'> = {
  INCOME: 'default',
  EXPENSE: 'destructive',
}
